module.exports = __webpack_public_path__ + "static/img/2.f651ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/2.png
// module id = u9y0
// module chunks = 0